export default __webpack_public_path__ + "static/media/background-time-sheet.61660031.svg";